<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
  color: #333;
}

h1, h2, h3, h4, h5, h6 {
  color: #333 !important;
}

/* 全局主色调 #2C90FF */
.ant-btn-primary {
  background-color: #2C90FF;
  border-color: #2C90FF;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background-color: #55A8FF;
  border-color: #55A8FF;
}
.ant-btn-primary:active,
.ant-btn-primary.active {
  background-color: #1A75E0;
  border-color: #1A75E0;
}
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover {
  background-color: #8AB8FF;
  border-color: #8AB8FF;
}
/* 链接型按钮、文字按钮使用主色 */
.ant-btn-link,
.ant-btn-link:hover,
.ant-btn-link:focus {
  color: #2C90FF;
}
/* 选中状态、a标签主色 */
a {
  color: #2C90FF;
}
.ant-switch-checked {
  background-color: #2C90FF;
}
/* Ant Design Vue v1 primary色相关组件 */
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #2C90FF;
  background: #fff;
  border-color: #2C90FF;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #2C90FF;
  border-color: #2C90FF;
}
.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #2C90FF;
}
.ant-tabs-ink-bar {
  background-color: #2C90FF;
}
.ant-pagination-item-active {
  border-color: #2C90FF;
}
.ant-pagination-item-active a {
  color: #2C90FF;
}
.ant-pagination-item:hover {
  border-color: #2C90FF;
}
.ant-pagination-item:hover a {
  color: #2C90FF;
}
</style>
